export default __webpack_public_path__ + "static/media/rw.45081f88.svg";